export default function ({ store, redirect }) {
  if (store.getters['user/isPortalUser'] && store.state['user']?.currentLogin?.factfind_enabled === false) {
    return redirect('/');
  }
}
